import lang from "@/views/modules/WorkPackages/language/en";
import breadcrumbs from "@/views/modules/WorkPackages/MenuList.vue";
import loader from "@/views/shared/loading/Loading.vue";
import Datepicker from 'vuejs-datepicker';

export default {
    name: "list-workpackages",
   
    components: {
        breadcrumbs,
        Datepicker,
        loader,
    },
    data() {
        return {
            page: 1,
            search: '',
            sort: {
                order: 'asc',
                column: 'date_entered',
            },
            perPage: 10,
            loading: true,
            dataList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang:[],
           
        }
    },
    mounted() {
        this.getProducts();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getProducts();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getProducts();
        },
        getProducts() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/workpackages', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.dataList = response.data.items;
               
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getProducts();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}